import React, { useState } from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './/reminder.css';

const getMonthName = (monthIndex) => {
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    return monthNames[monthIndex];
  }
  

const ReminderSection = () => {
  // Get the products from the local storage
  const products = JSON.parse(localStorage.getItem('products')) || [];

  // Get the current date
  const currentDate = new Date();

  // State to store the selected products for shoplist
  const [selectedProducts, setSelectedProducts] = useState([]);

  // Function to handle "Buy Again" checkbox change
  const handleBuyAgainChange = (productName) => {
    const currentMonthName = getMonthName(new Date().getMonth());
  
    setSelectedProducts((prevProducts) => {
      const productExists = prevProducts.some(product => product.name === productName);
  
      let updatedProducts;
      if (productExists) {
        updatedProducts = prevProducts.filter((product) => product.name !== productName);
      } else {
        updatedProducts = [...prevProducts, { name: productName, month: currentMonthName }];
      }
  
      localStorage.setItem('selectedProducts', JSON.stringify(updatedProducts));
  
      return updatedProducts;
    });
  };
    

  // Filter the products to get the ones that are going to expire and the ones that have expired
  const goingToExpireProducts = products.filter(product => {
    const expirationDate = new Date(product.expirationDate);
    const reminderDate = new Date(expirationDate);
    reminderDate.setDate(reminderDate.getDate() - parseInt(product.reminder));

    return currentDate >= reminderDate && currentDate <= expirationDate;
  });

  const expiredProducts = products.filter(product => {
    const expirationDate = new Date(product.expirationDate);
    return expirationDate < currentDate;
  });

  return (
    <div>
      <h3>Going to Expire</h3>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Product Name</th>
            <th>Location</th>
            <th>Days Remaining</th>
          </tr>
        </thead>
        <tbody>
          {goingToExpireProducts.map((product, index) => {
            const expirationDate = new Date(product.expirationDate);
            const reminderDate = new Date(expirationDate);
            reminderDate.setDate(reminderDate.getDate() - parseInt(product.reminder));

            const daysRemaining = Math.ceil((expirationDate - currentDate) / (1000 * 60 * 60 * 24));

            return (
              <tr key={index}>
                <td>{product.name}</td>
                <td>{product.location}</td>
                <td>{daysRemaining} days</td>
              </tr>
            );
          })}
        </tbody>
      </Table>

      <h3>Expired</h3>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Product Name</th>
            <th>Location</th>
            <th>Status</th>
            <th>Buy Again</th>
          </tr>
        </thead>
        <tbody>
          {expiredProducts.map((product, index) => (
            <tr key={index}>
              <td>{product.name}</td>
              <td>{product.location}</td>
              <td>Expired</td>
              <td>
                <input
                  type="checkbox"
                  id={`buyAgain-${index}`}
                  name="buyAgain"
                  value="buyAgain"
                  onChange={() => handleBuyAgainChange(product.name)} // Call the handler on checkbox change
                />
                <label htmlFor={`buyAgain-${index}`}></label>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Link to "/shoplist" with selected products as state */}
     {/* Link to "/shoplist" with selected products as state */}
    <Link to={{ pathname: '/shoplist', state: { selectedProducts } }} >
    <button className="btn btn-light">Add Selected to Shoplist</button>
    </Link>

    </div>
  );
};

export default ReminderSection;
